import React from "react"
import { Pressable } from "react-native"
import { Body } from "@/components/standard/BFText"
import { cn } from "@/components/util/cn"
import IconX from "phosphor-react-native/src/icons/XCircle"

interface BFTagProps {
  id: string
  title: string
  backgroundColor?: string
  textColor?: string
  onRemove?: (id: string) => void
  className?: string
}

const BFTag: React.FC<BFTagProps> = ({
  id,
  title,
  backgroundColor = "bg-lightest",
  textColor,
  onRemove,
  className,
}) => {
  return (
    <Pressable
      testID={`remove-tag-${title}`}
      onPress={() => onRemove?.(id)}
      accessibilityLabel={`Remove ${title}`}
      className={cn(
        "flex-row items-center self-start rounded-[2px] px-2 py-[8px] gap-1",
        backgroundColor,
        className
      )}
      hitSlop={16}
    >
      <Body className={cn("font-spacegrotesk", textColor)}>{title}</Body>
      {onRemove && <IconX size={12} color={textColor} weight="bold" />}
    </Pressable>
  )
}

export default BFTag

// TODO: Compare this component to src/components/properties/PropertyCard.tsx and refactor it to be reusable there
